import { ReactElement, useEffect } from 'react';
import { env } from 'config';

const win = window as Record<string, any>;

export const ContentSquare = (): ReactElement => {
  useEffect(() => {
    win._uxa = win._uxa || [];

    if (typeof win.CS_CONF === 'undefined') {
      win._uxa.push([
        'setPath',
        window.location.pathname + window.location.hash.replace('#', '?__'),
      ]);

      if (!document.getElementById('contentsquare-script')) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'contentsquare-script';
        script.async = true;
        script.src = `//t.contentsquare.net/uxa/${env.CONTENTSQUARE_TAG_ID}.js`;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    } else {
      win._uxa.push([
        'trackPageview',
        window.location.pathname + window.location.hash.replace('#', '?__'),
      ]);
    }
  }, []);

  return <></>;
};

export default ContentSquare;
